<template>
    <div class="employeeLIstVue">
        <div class="o-main-content-area">
            <div v-if="!mergeStatus" class="row c-responsive-fixwidth">
                <div class="col-md-3">
                    <h1 class="h1">Employees</h1>
                </div>
                <div class="col-md-9 text-right">
                    <ul class="o-filter-area">
                        <li class="o-search-field">
                            <div class="input-group stylish-input-group">
                                <input type="text" class="form-control" placeholder="Search" v-model="search_query" v-on:keyup="updateValue">
                                <span class="input-group-addon">
                                    <button type="submit">
                                    <span class=""><i class="fa fa-search" aria-hidden="true"></i></span>
                                </button>
                                </span>
                            </div>
                        </li>
                    </ul>
                </div>
            </div>
        </div>

        <div class="o-ndividualArea c-responsive-fixwidth">
            <div class="o-ndividualTable">                
                <div class="c-common-space o-individual-calls">
                    <div  class="col-md-9 o-no-padding">
                        <form v-if="!mergeStatus" class="form-inline">
                            
                            <div class="form-group ">
                                <label for="exampleInputEmail3" class="common-label-text">Sort By</label>
                                <div class="o-cutsomSelect o-display-inline">
                                    <select v-model="selectedShortType" @change="getAllEmployee()" class="form-control fix-width-input">
                                        <option value="fname_asc">FirstLast (Employee name)</option>
                                        <option value="fname_desc">LastFirst (Employee name)</option>
                                        <option value="email">Email ID</option>      
                                    </select>
                                </div>
                            </div>
                        </form>
                        <p v-if="mergeStatus" class="u-back"><a @click="mergeStatus=false" href="javascript: void(0)"><i class="fa fa-chevron-left"></i> Back</a></p>
                    </div>
                    <div class="col-md-3 o-no-padding text-right">
                        <button v-if="!mergeStatus" @click="mergeOpen()" type="submit" class="c-common-btn c-common-btn--green">Merge</button>
                        <button v-if="mergeStatus" @click="submitMerge()" type="submit" class="c-common-btn c-common-btn--green">Save</button>
                    </div>
                    
                </div>
                
                <div v-if="mergeStatus" class="c-common-space c-responsive-fixwidth c-radius3">
                    <div class="c-common-box-shadow c-radius3 c-user-tab-content clearfix o-skillset-area">
                        <div v-for="(user, indx) in userMerge" :key="indx" class="field-group">
                            <div class="row row-custom">
                                <div class="col-sm-12">
                                    <div class="c-common-space c-responsive-fixwidth">
                                        <div class="clearfix o-skillset-area">
                                            <p>Employee: {{user.name}}</p>
                                            <div class="row">
                                                <div class="col-sm-2">
                                                    <div class="form-group ">
                                                        <label class="common-label-text">Primary:</label>
                                                        <input type="radio" name="primary-radio" v-model="primary_id" :value="user.id">
                                                        <input type="text" class="form-control" v-model="user.name">
                                                    </div>
                                                </div>
                                                <div class="col-sm-2">
                                                    <div class="form-group ">
                                                        <label class="common-label-text">Primary Email:</label>
                                                        <input type="text" v-model="user.email" class="form-control" placeholder="Primary Email" :disabled="user.id==primary_id">
                                                    </div>
                                                </div>
                                                <div class="col-sm-2">
                                                    <div class="form-group ">
                                                        <label class="common-label-text">Secondary Email:</label>
                                                        <input type="text" v-model="user.secondary_email" class="form-control" placeholder="Secondary Email">
                                                    </div>
                                                </div>
                                                <div class="col-sm-2">
                                                    <div class="form-group ">
                                                        <label class="common-label-text">Home Phone:</label>
                                                        <input type="number" class="form-control" v-model="user.home_phone" placeholder="Home Phone">
                                                    </div>
                                                </div>
                                                <div class="col-sm-2">
                                                    <div class="form-group ">
                                                        <label class="common-label-text">Cell Phone:</label>
                                                        <input type="number" class="form-control" v-model="user.cell_phone" placeholder="Cell Phone">
                                                    </div>
                                                </div>
                                                <div class="col-sm-2">
                                                    <div class="form-group ">
                                                        <label class="common-label-text">Social:</label>
                                                        <input type="text" class="form-control" v-model="user.social_security" placeholder="Social">
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div v-if="!mergeStatus" class="o-skills-listing">
                    <div class="row">
                        <div class="col col-sm-12">
                        <div class="o-scheduleTable--daily">
                            <div 
                                infinite-scroll-disabled="busy" 
                                infinite-scroll-distance="10" 
                                v-loading="loading"
                                v-infinite-scroll="{ handler: handleScroll, distance: 10 }"
                                ref="scrollContainer"
                                style="min-height: 1px;overflow:auto;"
                            >
                                <div 
                                    v-for="(user, indx) in users" :key="indx" 
                                    class="o-calls-table c-common-gradient c-common-box-shadow c-radius3 c-margin-bottom-10 employees-list-table-align employees-list-table"
                                >
                                    <div class="calls-table-row">
                                        <div class="calls-table-cell">
                                            <div class="o-right-side-padding5">
                                                <div class="calls-table-cell-inner-table o-modal-trigger" data-toggle="modal" data-target="#employeeSummaryModal">
                                                    <div class="o-accordion-subtext o-rowtable-text">
                                                        <input type="checkbox" @change="getUserArray()" v-model="selectedEmployeeToMerge" :value="user">
                                                    </div>
                                                    <div class="o-accordion-subtext user-icon o-list-user-img">
                                                        <div class="o-post-logged o-post-logged--table-user">
                                                            <div class="o-user-profile-img o-header-profile-pic">
                                                                
                                                                <img v-if="user.image && user.image != '' && user.image != 'NULL'" :src="(user.image)"  id='img-upload'/>
                                                                <img v-if="!user.image && user.image == '' || user.image == 'NULL'" src="static/assets/images/user1.png" id='img-upload' />
                                                            
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div class="o-accordion-subtext o-rowtable-text">
                                                        <span>Name</span>
                                                        <div>{{(selectedShortType=='fname_asc')?user.first_name+" "+user.last_name:(selectedShortType=='fname_desc'?user.last_name+", "+user.first_name:employee.employable.first_name+" "+employee.employable.last_name)}}</div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>                                 
                                        <div class="calls-table-cell">
                                            <div class="table-td-border-right table-td-border-left o-right-side-padding5">
                                                <div class="o-accordion-subtext o-rowtable-text">
                                                    <span>Primary Email :</span>
                                                    <div>{{user.email}}</div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="calls-table-cell">
                                            <div class="table-td-border-right o-right-side-padding5">
                                                <div class="o-accordion-subtext o-rowtable-text">
                                                    <span>Secondary Email:</span>
                                                    <div>{{user.secondary_email && user.secondary_email!='' && user.secondary_email !='NULL'?user.secondary_email:'- - - - - - - - '}}</div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="calls-table-cell">
                                            <div class="table-td-border-right o-right-side-padding5">
                                                <div  class="o-accordion-subtext o-rowtable-text">
                                                    <span>Home Phone:</span>
                                                    <div 
                                                        v-for="(phone,index) in user.phones" :key="index" 
                                                        v-if="phone.label=='Home phone' || phone.label=='home'">
                                                        {{phone.phone_number}}
                                                    </div>                                                    
                                                </div>
                                            </div>
                                        </div>
                                        <div class="calls-table-cell">
                                            <div class="table-td-border-right o-right-side-padding5">
                                                <div class="o-accordion-subtext o-rowtable-text">
                                                    <span>Cell Phone:</span>
                                                    <div 
                                                        v-for="(phone,index) in user.phones" :key="index" 
                                                        v-if="phone.label=='Cell phone' ||  phone.label=='mobile' || phone.label=='cell'">
                                                        {{phone.phone_number}}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>                                        
                                        <div class="calls-table-cell">
                                            <div class="o-right-side-padding5">
                                                <div  class="o-accordion-subtext o-rowtable-text">
                                                                                                    
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            </div>
                        </div>
                    </div>
                    <div v-if="users.length==0 && afterApi">
                        <div class="c-common-space c-common-gradient c-common-box-shadow c-radius3">
                            <div class="col-md-12 no-job-dispaly">
                                <i class="fa fa-frown-o" aria-hidden="true"></i>
                                <br />
                                No Data Stored
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import {
        mapGetters,
        mapActions
    } from 'vuex';
    import dateTimeConvert from '../../../timeConvert&Compare.js';
    import {
        VueEditor
    } from 'vue2-editor';
    import service from '../../../services.js';
    import {
        global
    } from '../../../global.js';
    let timeout = null;
    export default {
        components: {
            VueEditor
        },
        computed: {
            ...mapGetters({
                userToken: 'userToken',
                userRole: 'userRole',
                userID: 'userID',
            }),    
        },
        data() {
            return {   
                loading:true,
                afterApi:false,   
                selectedShortType:'fname_asc',
                search_query:'',
                users:[], 
                savedEmployees:[],
                last_page:null,
                next_page:null,
                selectedEmployeeToMerge:[],
                mergeStatus:false,
                userMerge:[],
                primary_id:'',
            }
        },
        beforeMount() {
            this.getAllEmployee();
        },
        methods: {
            getUserArray(){
                this.userMerge=[];
                this.selectedEmployeeToMerge.forEach(user =>{
                    let item ={
                        id: user.id,
                        name: user.first_name+' '+user.last_name,
                        email: user.email,
                        secondary_email: user.secondary_email,
                        home_phone: this.getPh(user.phones,'home_phone'),
                        cell_phone: this.getPh(user.phones,'cell_phone'),
                        social_security: user.social_security
                    };
                    this.userMerge.push(item);
                });
            },

            getDate(date){
                return dateTimeConvert.localDate(date);
            },

            mergeOpen(){
                if(this.selectedEmployeeToMerge.length>1){
                    this.mergeStatus=true;
                }else{
                    this.$notify.error({
                        title: this.$t('error'),
                        message: 'Please select at least two employees.'
                    });	
                }
            },
            
            submitMerge(){
                if(this.primary_id && this.primary_id!=''){
                    let secondary_ids=[];
                    let fromData={};
                    this.userMerge.forEach(user =>{
                        if(this.primary_id==user.id){
                            fromData=user;
                        }else{
                            secondary_ids.push(user.id);
                        }
                    });
                    fromData.primary_id=this.primary_id;
                    fromData.secondary_ids=secondary_ids;
                    fromData.name=fromData.name?fromData.name.replace(/^\s+|\s+$/g, ""):'';
                    if(fromData.name && fromData.name.split(' ').length > 1){
                        fromData.first_name=fromData.name.split(' ').slice(0, -1).join(' ');
                        fromData.last_name=fromData.name.split(' ').slice(-1).join(' ')
                    }else{
                        fromData.first_name=fromData.name;
                        fromData.last_name='';
                    }
                    service.post('superadmin/mergeEmployees', fromData, {
                        'Authorization': this.userToken,
                        'cs3-context-role': this.userRole,
                    }).then((res) => {
                        this.selectedEmployeeToMerge=[];
                        this.mergeStatus=false;
                        this.$notify({
                            title: this.$t('success'),
                            message: 'User merged Successfully.',
                            type: 'success'
                        });
                        this.$router.push({
                            'path': '/adminEmployeeList'
                        });
                    }).catch(err =>{
                        console.log(err);
                    }); 
                }else{ 
                    this.$notify.error({
                        title: this.$t('error'),
                        message: 'Please select primary user.'
                    });	
                }
            },

            getPh(phones, type){
                for(let key in phones)
         		{
                    switch(phones[key].label){
                        case 'Primary phone':
                            if(type=='home_phone')
                                return phones[key].phone_number;
                            break;
                        case 'Home phone':
                            if(type=='home_phone')
                                return phones[key].phone_number;
                            break;
                        case 'Secondary phone':
                            if(type=='cell_phone')
                                return phones[key].phone_number;
                            break;
                        case 'Cell phone':
                            if(type=='cell_phone')
                                return phones[key].phone_number;
                            break;
                        default:
                            // console.log('label not found');

                    }
                }
            },

            updateValue(){
                clearTimeout(timeout);
                timeout = setTimeout(() => {
                    this.getAllEmployee();
                }, 1000);
            },

            getAllEmployee() {
                this.$Progress.start();
                this.loading = true;
                this.afterApi = false;
                this.users=[];
                this.savedEmployees =[];
                service.get('superadmin/getEmployeesMergerList', {
                    'Authorization': this.userToken,
                    'cs3-context-role': this.userRole,
                    'status': 'all',
                    'sort': this.selectedShortType,
                    'search': this.search_query,
                }).then((res) => {
                    this.users = res.data.result.data;
                    this.$Progress.finish();
                    this.last_page = res.data.result.total;
                    this.next_page = res.data.result.next_page_url;
                    this.loading = false;
                    this.afterApi = true;
                    if (this.next_page != null || this.next_page != "") {
                        service.getUrl(this.next_page, {
                            'Authorization': this.userToken,
                            'cs3-context-role': this.userRole,
                            'status': 'all',
                            'sort': this.selectedShortType,
                            'search': this.search_query,
                        }).then((res) => {
                            this.savedEmployees = res.data.result.data;
                            this.next_page = res.data.result.next_page_url;

                        }).catch((err) => {
                            console.log(err);
                        });
                    } 
                }).catch((err) => {
                    console.log(err);
                    this.loading = false;
                    this.afterApi = true;
                });
            },

            async handleScroll() {
                if (position !== "bottom") return; 
                await this.loadMore();
            },

            async loadMore() {
                var arr = this.users;
                if (this.savedEmployees.length != 0) {
                    this.savedEmployees.forEach(function(entry) {
                        arr.push(entry);
                    })
                    this.savedEmployees=[];
                    if (this.next_page != null || this.next_page != "") {
                        service.getUrl(this.next_page, {
                            'Authorization': this.userToken,
                            'cs3-context-role': this.userRole,
                            'status': 'all',
                            'sort': this.selectedShortType,
                            'search': this.search_query,
                        }).then((res) => {
                            this.savedEmployees = res.data.result.data;
                            this.page_no += 1;
                            this.next_page = res.data.result.next_page_url;

                        }).catch((err) => {
                            console.log(err);
                        });
                    }else
                        this.savedEmployees = [];
                }
                this.$nextTick(() => {
                    if (this.$refs.scrollContainer && this.$refs.scrollContainer._checkScroll) {
                        this.$refs.scrollContainer._checkScroll();
                    }
                });
            },
            
        },
        
        created() {            
        }

    }

</script>
<style>
    .pointHere {
        cursor: pointer;
    }

    .tooltip {
        display: block !important;
        z-index: 10000;
    }

    .tooltip .tooltip-inner {
        background: #f9ffb5;
        color: black;
        border-radius: 16px;
        padding: 5px 10px 4px;
    }

    .tooltip .tooltip-arrow {
        width: 0;
        height: 0;
        border-style: solid;
        position: absolute;
        margin: 5px;
        border-color: #f9ffb5;
    }

    .tooltip[x-placement^="top"] {
        margin-bottom: 5px;
    }

    .tooltip[x-placement^="top"] .tooltip-arrow {
        border-width: 5px 5px 0 5px;
        border-left-color: transparent !important;
        border-right-color: transparent !important;
        border-bottom-color: transparent !important;
        bottom: -5px;
        left: calc(50% - 5px);
        margin-top: 0;
        margin-bottom: 0;
    }

    .tooltip[x-placement^="bottom"] {
        margin-top: 5px;
    }

    .tooltip[x-placement^="bottom"] .tooltip-arrow {
        border-width: 0 5px 5px 5px;
        border-left-color: transparent !important;
        border-right-color: transparent !important;
        border-top-color: transparent !important;
        top: -5px;
        left: calc(50% - 5px);
        margin-top: 0;
        margin-bottom: 0;
    }

    .tooltip[x-placement^="right"] {
        margin-left: 5px;
    }

    .tooltip[x-placement^="right"] .tooltip-arrow {
        border-width: 5px 5px 5px 0;
        border-left-color: transparent !important;
        border-top-color: transparent !important;
        border-bottom-color: transparent !important;
        left: -5px;
        top: calc(50% - 5px);
        margin-left: 0;
        margin-right: 0;
    }

    .tooltip[x-placement^="left"] {
        margin-right: 5px;
    }

    .tooltip[x-placement^="left"] .tooltip-arrow {
        border-width: 5px 0 5px 5px;
        border-top-color: transparent !important;
        border-right-color: transparent !important;
        border-bottom-color: transparent !important;
        right: -5px;
        top: calc(50% - 5px);
        margin-left: 0;
        margin-right: 0;
    }

    .tooltip[aria-hidden='true'] {
        visibility: hidden;
        opacity: 0;
        transition: opacity .15s, visibility .15s;
    }

    .tooltip[aria-hidden='false'] {
        visibility: visible;
        opacity: 1;
        transition: opacity .15s;
    }
    .form-control-custom{
        margin-left: 10px !important;
        display: block;
    }
    .row-custom {
        margin-left: -10px !important;
        margin-right: -10px !important;
    }
</style>
